if (!customElements.get('product-image-comparison-slider')) {
  customElements.define(
    'product-image-comparison-slider',
    class ProductImageComparisonSlider extends HTMLElement {
      connectedCallback() {
        this.viewport = this.querySelector('.swiper');
        this.initSlider();
      }

      initSlider() {
        const paginationEl = this.querySelector('.swiper-pagination');

        // Navigation is dots-only here, not swipe/drag - the comparison media
        // itself already has its own left/right drag gesture (dragging the
        // before/after handle), so letting the slide track ALSO respond to
        // drag made the two gestures fight each other.
        const options = {
          slidesPerView: 1,
          spaceBetween: 24,
          allowTouchMove: false,
          simulateTouch: false,
          navigation: false,
          pagination: paginationEl
            ? {
                el: paginationEl,
                clickable: true,
              }
            : false,
          watchOverflow: true,
        };

        this.sliderInstance = new FoxTheme.Carousel(this.viewport, options);
        this.sliderInstance.init();
      }
    }
  );
}
